<template>
  <Block :data="data.value" />
</template>

<script setup>
  const props = defineProps({
    data: {}
  })

  const name = toPascalCase(props.data.type)
  const Block = defineAsyncComponent(async () => {
    try {
      return await import(`../blocks/${name}.vue`)
    } catch (e) {
      console.error(`Error importing ${name}.vue`)
    }
  })

  function toPascalCase(name) {
    try {
      return name
        .split('_')
        .map(i => i[0].toUpperCase() + i.slice(1, i.length))
        .join('')
    } catch (e) {
      return ''
    }
  }
</script>
